import { useSyncExternalStore } from "react";

// Шрифт панели: «лёгкий» — Manrope для всего, тонкий и компактный, он по
// умолчанию; «плотный» — Sora (латиница) с утяжелённой кириллицей, шире и
// жирнее. Выбор живёт в браузере и ставится на <html> атрибутом data-font, на
// который смотрит CSS; AntD берёт семейство из того же места через
// ThemeProvider. Кто сам выбрал плотный, у того он и остаётся.
const STORAGE_KEY = "kl-font-mode";
const MODES = ["dense", "light"];

const read = () => {
  if (typeof window === "undefined") return "light";
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return MODES.includes(stored) ? stored : "light";
  } catch (_) { return "light"; }
};

let current = read();
const listeners = new Set();

const applyToDocument = (mode) => {
  if (typeof document === "undefined") return;
  if (mode === "light") document.documentElement.setAttribute("data-font", "light");
  else document.documentElement.removeAttribute("data-font");
};
applyToDocument(current);

export const getFontMode = () => current;

export const setFontMode = (mode) => {
  const next = MODES.includes(mode) ? mode : "light";
  if (next === current) return;
  current = next;
  applyToDocument(next);
  try { window.localStorage.setItem(STORAGE_KEY, next); } catch (_) { /* приватный режим */ }
  listeners.forEach((listener) => { try { listener(); } catch (_) { /* слушатель сам разберётся */ } });
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useFontMode = () => useSyncExternalStore(subscribe, getFontMode, getFontMode);

export const FONT_STACK_DENSE = "Sora, Manrope, Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
export const FONT_STACK_LIGHT = "Manrope, Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
